import { render, staticRenderFns } from "./PayMethod.vue?vue&type=template&id=cb0a8cf0&scoped=true"
import script from "./PayMethod.vue?vue&type=script&lang=js"
export * from "./PayMethod.vue?vue&type=script&lang=js"
import style0 from "./PayMethod.vue?vue&type=style&index=0&id=cb0a8cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0a8cf0",
  null
  
)

export default component.exports